import getProductionConfig from './config.production';

export default getProductionConfig();
